// src/pages/DashboardPage.js

import React from 'react';
import styled from 'styled-components';
import Dashboard from '../components/Dashboard/Dashboard';
import Footer from '../components/common/Footer';
import ErrorBoundary from '../components/common/ErrorBoundary';
import { media } from '../utils/media'; // Import media utility

const DashboardPage = () => {
  return (
    <PageContainer>
      <ErrorBoundary>
        <Dashboard />
      </ErrorBoundary>
    </PageContainer>
  );
};

export default DashboardPage;

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.primaryBackground};
  background-image: linear-gradient(
    to bottom right,
    ${({ theme }) => theme.colors.primaryBackground} 0%,
    ${({ theme }) => theme.colors.primaryBackground} 100%
  );
  position: relative;
  overflow-x: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 200px;
    background: linear-gradient(
      to bottom,
      ${({ theme }) => theme.colors.accentBlue}15,
      transparent
    );
    z-index: 0;
  }

  ${media.tablet(`
    padding: 0;
  `)}

  ${media.mobile(`
    padding: 0;
  `)}
`;
